import { observer } from 'mobx-react';

import VideoSlideComponent from './VideoSlideComponent';

import './style.scss';

const SampleVideo = observer(({ data }) => {
    return (
        <div className="sample-movie">
            <div className="sub-title-2">{data?.title}</div>
            <div className="desc" style={{ whiteSpace: 'pre-wrap' }}>
                {data?.content}
            </div>

            <div className='list-course-content'>
                {Array.isArray(data?.sampleVideos) && data?.sampleVideos?.length > 0 ? (
                    <VideoSlideComponent slides={data?.sampleVideos} />
                ) : (
                    <div className="mg-t-30 mg-b-95">データはありません</div>
                )}
            </div>
        </div>
    );
});

export default SampleVideo;
